﻿import React, { useState } from 'react';
import { Button } from '@mui/material';
import { EmailForm } from '../../../api/marketing.js';
import { useMutation } from '@tanstack/react-query';
import { useUser } from '../../../context/UserContext';

const SendEmailButton = ({ cartItems, callback }) => {
  const user = useUser();

  const calculateSubtotal = () => {
    return cartItems.reduce((subtotal, item) => subtotal + item.price * item.quantity, 0);
  };
  const emailForm = useMutation({
    mutationFn: (data) => EmailForm(data)(),
  });

  function handleSendEmail() {
    const recipientEmailAddress = 'jon.bednez@baltlife.com';
    let messageSubject = 'Promo Item Cart Results';
    let messageBody = '';
    let test = '';

    cartItems.forEach((listValue, index) => {
      test += `
            <tr style="border: 1px solid black; border-collapse: collapse; padding: 15px;" key=${index}>
                <td style="border: 1px solid black; border-collapse: collapse; padding: 15px;" >${listValue.title}</td>
                <td style="border: 1px solid black; border-collapse: collapse; padding: 15px;">${listValue.color}</td>
                <td style="border: 1px solid black; border-collapse: collapse; padding: 15px;">${listValue.size}</td>
                <td style="border: 1px solid black; border-collapse: collapse; padding: 15px;">${listValue.quantity}</td>
                <td style="border: 1px solid black; border-collapse: collapse; padding: 15px;">$${(listValue.price * listValue.quantity).toFixed(2)}</td>
            </tr>
        `;
    });

    let messageTitle = 'This message was sent by: ' + user.emailAddress;

    messageBody += `
            <div>${messageTitle}\n</div>
            </hr>
            </br>
            <table style="border: 1px solid black; border-collapse: collapse; padding: 15px;">
                <tr style="border: 1px solid black; border-collapse: collapse; padding: 15px;">
                    <th style="border: 1px solid black; border-collapse: collapse; padding: 15px;">Title</th>
                    <th style="border: 1px solid black; border-collapse: collapse; padding: 15px;">Color</th>
                    <th style="border: 1px solid black; border-collapse: collapse; padding: 15px;">Size</th>
                    <th style="border: 1px solid black; border-collapse: collapse; padding: 15px;">Quantity</th>
                    <th style="border: 1px solid black; border-collapse: collapse; padding: 15px;">Subtotal</th>
                </tr>
                ${test}
            </table>
            </br>
            </hr>
            <div><b>\nTotal: $${calculateSubtotal().toFixed(2)}</b></div>
        `;

    emailForm.mutate(
      {
        FormFileName: '',
        FormName: '',
        RecipientEmailAddress: recipientEmailAddress,
        SenderEmailAddress: 'noreply@baltlife.com',
        MessageSubject: messageSubject,
        MessageBody: messageBody,
      },
      {
        onSuccess: (d) => {
          callback(d);
        },
      }
    );
  }

  return (
    <>
      <Button variant="contained" color="primary" onClick={handleSendEmail}>
        Send Email
      </Button>
    </>
  );
};

export default SendEmailButton;
